// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2QRek","right":"Footer_right__3r5VR","buttons":"Footer_buttons__3qbXY"};